import InstagramPostsQuery from "@apps/instagram/queries/InstagramPostsQuery";
import InstagramStoriesQuery from "@apps/instagram/queries/InstagramStoriesQuery";
import InstagramTaggedProductQuery from "@apps/instagram/queries/InstagramTaggedProductQuery";
import InstagramPostsServiceInterface from "@apps/instagram/services/InstagramPostsService/InstagramPostsServiceInterface";
import InstagramStoriesService from "@apps/instagram/services/InstagramStoriesService/InstagramStoriesService";
import InstagramTaggedProductService from "@apps/instagram/services/InstagramTaggedProductService";
import InstagramTrackersApiService from "@apps/instagram/services/InstagramTrackersService";
import InstagramPostsStore from "@apps/instagram/stores/InstagramPostsStore";
import InstagramStoriesStore from "@apps/instagram/stores/InstagramStoriesStore";
import { InjectionKey } from "@lib/svelte-typed-context";
import ModulesStatusesProvider from "@modules/base_module/ModulesStatusesProvider/ModulesStatusesProvider";
import { CartQuery } from "@modules/cart/queries/CartQuery";
import { CartService } from "@modules/cart/services/CartService";
import CartAvailabilityProvider from "@modules/common_module/CartAvailabilityProvider/CartAvailabilityProvider";
import type LocationControllerInterface from "@modules/common_module/LocationController/LocationControllerInterface";
import { URLsBuilder } from "@modules/common_module/URLsBuilder/URLsBuilder";
import { GwI18n } from "@modules/i18n/GwI18n/GwI18n";
import type { TrackingApiServiceInterface } from "@modules/legacy_tracking/services/TrackingApiServiceInterface";
import HTMLSanitizerInterface from "@modules/money/HTMLSanitizer/HTMLSanitizerInterface";
import { ProductsQuery } from "@modules/products/queries/ProductsQuery";
import type { ProductsServiceInterface } from "@modules/products/services/ProductsServiceInterface";

export const instagramGalleryWidgetContextToken: InjectionKey<{
    taggedProductService: InstagramTaggedProductService;
    taggedProductQuery: InstagramTaggedProductQuery;
    instagramStoriesQuery: InstagramStoriesQuery;
    instagramStoriesService: InstagramStoriesService;
    instagramStoriesStore: InstagramStoriesStore;
    instagramPostsQuery: InstagramPostsQuery;
    instagramPostsService: InstagramPostsServiceInterface;
    instagramPostsStore: InstagramPostsStore;
    instagramTrackersService: InstagramTrackersApiService;
    trackingApiService: TrackingApiServiceInterface;
    cartService: CartService;
    cartQuery: CartQuery;
    locationController: LocationControllerInterface;
    productsService: ProductsServiceInterface;
    productsQuery: ProductsQuery;
    gwi18n: GwI18n;
    urlsBuilder: URLsBuilder;
    htmlSanitizer: HTMLSanitizerInterface;
    cartAvailabilityProvider: CartAvailabilityProvider;
    modulesStatusesProvider: ModulesStatusesProvider;
}> = Symbol("instagramGalleryWidgetToken");
